import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiFillCaretDown, AiOutlineRadarChart, AiTwotoneExperiment } from "react-icons/ai";



function HeaderBtn(props) {

    const [isOverBtn, setIsOverBtn] = useState(false);
    const [isOverList, setIsOverList] = useState(false);

    const handleMouseEnterBtn = (event) => {
        setIsOverBtn(true)
    }
    const handleMouseLeaveBtn = (event) => {
        setIsOverBtn(false)
    }

    const handleMouseEnterList = (event) => {
        setIsOverList(true)
    }
    const handleMouseLeaveList = (event) => {
        setIsOverList(false)
    }


    const navigate = useNavigate()

    const iconLookUp = {
        'Simulator': <AiOutlineRadarChart />,
        'Blender': <AiTwotoneExperiment />,
    };


    
    return ( 
        <div className='flex-inline'>
            <div className='flex items-center'>
            <p className={`w-20 py-4 
                          ${(isOverBtn || isOverList) && 'font-bold'}`}
               onMouseEnter={handleMouseEnterBtn}
               onMouseLeave={handleMouseLeaveBtn}
             >{props.title}</p>
             <AiFillCaretDown className={`text-md mt-0.5 duration-300 ${(isOverBtn || isOverList) && 'rotate-180'}`}/> 
            </div>

            {/* {(isOverBtn || isOverList) &&  */}
            <div className='relative'
                 onMouseEnter={handleMouseEnterList}
                 onMouseLeave={handleMouseLeaveList}>
                <div className={`absolute -mt-8 py-4 w-24 transition duration-300 ${(isOverBtn || isOverList) ? 'opacity-100' : 'opacity-0'}`}>
                    <div className='bg-gray-200 rounded-md shadow-lg
                                    flex-inline absolute mt-2 w-32 px-4 py-4 space-y-3
                            text-gray-600 text-left'>
                    {props.list.map((item,index)=>(
                        <div key={index}
                             className='flex items-center space-x-1 hover:text-[#bb16a3]'>
                            {iconLookUp[item.title]}
                            <p className='hover:cursor-pointer hover:font-semibold 
                                          text-sm'
                               onClick={()=>navigate(item.to)}>{item.title}</p>                        
                        </div>
                    ))}
                    </div>
                </div>
            </div>
            {/* } */}
        </div>
     );
}

export default HeaderBtn;